import { render, staticRenderFns } from "./ifp-filter-assignees.vue?vue&type=template&id=285a9e94&"
import script from "./ifp-filter-assignees.vue?vue&type=script&lang=ts&"
export * from "./ifp-filter-assignees.vue?vue&type=script&lang=ts&"
import style0 from "./ifp-filter-assignees.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports